<template>
  <Modal :modalConfig="modalConfig" @onClose="btnClose">
    <div>
      <Map ref="TMap" @addressChange="handleAddressChange" @addressInit="handleAddressChange"></Map>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" icon="el-icon-check" size="small" @click="btnSubmit">提交</el-button>
      <el-button type="danger" icon="el-icon-check" size="small" @click="btnClose">关闭</el-button>
    </div>
  </Modal>
</template>
<script>
import Modal from '@/found/components/modal/components/modal.vue';
import Map from '@/found/components/tencent_map/map.vue';

export default {
  components: {
    Modal,
    Map,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      deep: true,
      immediate: true,
      handler(val) {
        this.modalConfig.visible = val;
        if (val) {
          // 避免没有重置位置
          setTimeout(() => {
            const { TMap } = this.$refs;
            if (!TMap) return false;
            TMap.initCityLocation();
          }, 1000);
        }
      },
    },
  },
  data() {
    return {
      modalConfig: {
        title: '打卡地点',
        visible: false,
        type: 'Modal',
        showFooter: false,
      },
      placeInfo: null,
    };
  },
  methods: {
    /** @desc 地图点击事件 */
    handleAddressChange(placeInfo) {
      this.placeInfo = placeInfo;
    },
    /** @desc 提交 */
    btnSubmit() {
      if (!this.placeInfo) return false;
      this.$emit('submit', { ...this.placeInfo });
      this.btnClose();
    },
    /** @desc 关闭 */
    btnClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="less" scoped>
  .form-map {
    margin-top: 20px;
  }
</style>
